module.exports = __webpack_public_path__ + "img/user2_active.fd07313e.svg";